<template>
  <div
    :class="{
      'operation-form': true,
      'operation-form--reverse-stack': isConfigurationForm,
    }"
  >
    <HeaderBar :modifiers="headerModifiers">
      <div
        v-if="!isConfigurationForm"
        class="header-bar__title typo-title"
      >
        {{ formState }} {{ $t(`operation_type.${operationType}`) }}
      </div>
      <div
        v-else
        class="header-bar__title typo-title hide-for-medium"
      >
        {{ $t(headerNav(operationType)) }}
      </div>

      <template #right>
        <a
          class="button"
          @click="$emit('cancel')"
        >
          {{ $t('general.cancel') }}
        </a>
        <FormSubmitButton
          :isDisabled="formDisabled"
          :isSaving="formSaving"
          @click="!formDisabled && $emit('update')"
        />
      </template>
    </HeaderBar>

    <div :class="{ 'operation-form__content': !isConfigurationForm }">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

// Utils
import I18n from 'i18n-js';
import { headerNav } from '@/functions/configuration';

// Components
import HeaderBar from '@/components/generic/header_bar.vue';
import FormSubmitButton from '@/components/form/form_submit_button.vue';

const props = defineProps({
  /** The `id` is used to identify if the form is new or not, assists us with showing the appropriate label text (New or Edit) */
  id: { type: String, required: false, default: null },
  /** The saving state of the form submission */
  formSaving: { type: Boolean, required: true, default: false },
  /** The disable state of the form submission */
  formDisabled: { type: Boolean, required: false, default: false },
  /** The operation type. Can only be `shaft`, `plant`, `ship` at the moment. */
  operationType: {
    type: String,
    required: true,
    default: 'plant',
    validator: (value) => [
      'organisation',
      'plant',
      'shaft',
      'ship',
      'station',
      'heavy_mobile_equipment',
      'mine',
      'equipment',
      'process',
      'type'
    ].includes(value),
  },
  /** Changes the styles to accommodate the configuration form */
  isConfigurationForm: { type: Boolean, default: false },
});

defineEmits(['update', 'cancel']);

const headerModifiers = computed(() => {
  return props.isConfigurationForm
    ? [
        'form',
        'no-margin-x',
        'margin-top',
        'full-max-width',
        'responsive',
      ]
    : ['form', 'transparent'];
});

const formState = computed(() => {
  return props.id ? I18n.t('general.edit') : I18n.t('general.new');
});
</script>
